//componente que muestra los siguientes componentes
//  Resumen de descuadres para la semana, obtenido de la base de datos (state.resumenCierreSemanal.resumen)
//  CalendarioSemanal - Tabla resumen de los valores de cada dia de la semana para cada zona (arcade, bolera, etc...)
//  Un CierreSemanalResumenItem  por cada item del resumen del cierre obtenido del servidor (state.resumenCierreSemanal.items)
//      divididos en Ingresos y Bancos
//  
//los datos se obtienen con la llamada getResumenCierreSemanal
//
//ITEMS:
//  Total Ingresos: Total arqueos de todas las zones excepto 9, 5, 11 (general, cambio y arcade) + ingresos lecturas de maquinas + gastos(D_A_Gasto) de zona 11
//  Visas: Suma de mMovEc de ikind=0 y isMovCaja=1
//      Abre componente CierreSemanalResumenVisas
//  Gastos: Suma de D_A_Gasto
//      Abre componente CierreSemanalResumenGastos
//  Var.Fondo: Variación de fondo de euros
//  MKT Pdte.: Suma de mMovEc de ikind=1 y isMovCaja=1
//      Abre componente CierreSemanalResumenMKT
//  Bancos: Suma de arqueos de zona 9 (general)
//      Abre componente CierreSemanalResumenBanco
//  Arcade: Arqueo de zona 5 (arcade)
//      

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Paper, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { Tooltip, Fade } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';

//actions:
import { getResumenCierreSemanal, cerrarSemana, unlockCierreSemanal } from '../../actions/cierre_semanal_actions';
import CierreSemanalResumenItem from './cierre_semanal_resumen_item';
import { openDialog } from '../../actions';

//components
import FloatNumberFormatText from '../../components/float_number_text_formatter';
import CalendarioSemanal from '../../components/dialogs/cierre_semanal_calendario';

import { createReport } from '../../dataLib';


const styles = theme => ({
    root: {
        padding: '8px 24px',
        margin: theme.spacing(1),
        flexGrow: 1,
    },
    container: {
        maxWidth: 1022,
        margin: 0,
        padding: 0
    },
    paperCaja: {
        backgroundColor: theme.palette.primary.light,
        boxShadow: 'none',
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
        borderRadius: '0px',
        margin: '20px 0',
        padding: 10,
        display: 'flex',
        flexDirection: 'column',
    },
    boxesContainer: {
        display: 'flex',
        justifyContent: 'space-evenly',
    },
    paperConcepto: {
        padding: 0,
        margin: 0,
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
        borderRadius: 0,
        width: '47%',
        backgroundColor: 'white',
        height: 'fit-content',
    },
    conceptTitle: {
        fontSize: '15px',
        fontWeight: '500',
        color: 'white',
        backgroundColor: theme.palette.primary.main,
    },
    containeritems: {
        width: '100%',
        margin: '8px auto',
    },
    cajaSection: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: 0,
        padding: '0 0 10px',
        borderRadius: 0,
        background: theme.palette.primary.light,
    },
    cajaSectionLeft: {
        display: 'flex',
        padding: '0 10px 0 8px',
        width: '50%',
        justifyContent: 'flex-end',
    },
    cajaSectionRight: {
        display: 'flex',
        justifyContent: 'space-between',
        width: 135,
    },
    cajaSectionItem: {
        display: 'flex',
        justifyContent: 'space-evenly',
        width: '35%',
    },
    cajaSectionFont: {
        fontSize: 13,
        fontWeight: '700',
    },
    paperZona: {
        padding: 0,
        margin: 0,
        borderRadius: 0,
        marginBottom: 28,
    },
    conceptTitleContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '4px 12px',
        backgroundColor: theme.palette.primary.main,
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    paperResumenTable: {
        backgroundColor: '#efefef',
        padding: theme.spacing(1),
        elevation: 3,
        maxWidth: 1022,
    },
    typoError: {
        fontSize: 13,
        color: 'red'
    },
    typoDefault: {
        fontSize: 13,
        color: 'black'
    },
    typoOK: {
        fontSize: 13,
        color: 'green'
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
    observTextField: {
        display: 'flex',
        height: 200,
        margin: 0,
        maxWidth: 1022,
    },
    inputObserv: {
        display: 'flex',
        alignItems: 'start',
        margin: '15px 0',
        padding: '5px 8px',
        fontSize: 12,
        height: '90%',
    },
});

class CierreSemanalResumen extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            acumBancos: 0.0,
            acumIngresos: 0.0,
            acumFondos: 0.0,
            observDescuadre: '',
            showSpinner: true,
        };
    };

    componentDidMount() {
        this.props.getResumenCierreSemanal(this.props.centroDiaSelected.centro.id, this.props.centroDiaSelected.dia);
    };

    componentDidUpdate(prevProps) {
        if (prevProps.itemsCierreSemanal !== this.props.itemsCierreSemanal) {

            let acumBancos = 0.0;
            let acumIngresos = 0.0;
            let acumFondos = 0.0;

            this.props.itemsCierreSemanal.forEach(item => {
                switch (item.orden) {
                    case 1:
                        acumIngresos += parseFloat(item.importe);
                        break;
                    case 4:
                        acumFondos += parseFloat(item.importe);
                        break;
                    case 100:
                    case 101:
                        acumBancos += parseFloat(item.importe.toFixed(2));
                        break;
                    default:
                        break;
                };
            });

            this.setState({
                acumBancos: acumBancos + this.props.gastosGeneral,
                acumIngresos: acumIngresos,
                acumFondos: acumFondos,
                observDescuadre: this.props.observDescuadre
            });
        }

        if (prevProps.isLoading !== this.props.isLoading && this.props.isLoading) this.setState({ showSpinner: true });
        if (prevProps.isLoading !== this.props.isLoading && !this.props.isLoading) this.setState({ showSpinner: false });
    };

    hanldeOKClick = () => {
        if (!this.props.isSemanaCerrada) {
            //update cierre diario datos data

            let descuadre = false;

            this.props.resumenCierreSemanal.forEach(item => descuadre = descuadre | item.iError === 1);

            if (descuadre && this.state.observDescuadre.trim() === '') {
                this.props.openDialog('SimpleMessage', {
                    message: 'Debe introducir observaciones por descuadre'
                }, 'error-cierre-semanal-obsrvaciones-resumen', false, false);
            }
            else {

                this.setState({ ...this.state, showSpinner: true });

                this.props.cerrarSemana(this.props.centroDiaSelected.centro.id, this.props.centroDiaSelected.dia, this.state.observDescuadre, () => {
                    
                    const win = window.open(process.env.PUBLIC_URL + '/loading_report.html', '_blank');

                    let url = '';

                    createReport(
                        {
                            reportDefinition: { id: 4 },
                            values: {
                                centroId: this.props.centroDiaSelected.centro.id,
                                wIniDate: this.props.centroDiaSelected.dia,
                                page: -1
                            }
                        },
                        "PDF",
                        this.props.user, '')
                        .then(response => {
                            url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
                            win.location.href = url;
                        }).catch(error => {
                            this.props.openDialog('SimpleMessage', {
                                message: error.response.status == 401 ? error.response.data : 'ERROR generating PDF'
                            }, 'error-opem-report-pdf', false, false);
                        }).then(() => {
                            this.setState({ ...this.state, showSpinner: false });
                        });

                }, () => {
                    this.setState({ ...this.state, showSpinner: false });
                });
            }
        }
        else {
            //
            this.props.unlockCierreSemanal(this.props.centroDiaSelected.centro.id, this.props.centroDiaSelected.dia);
            this.props.nextStep();
        }
        //this.props.nextStep();
    };


    renderIngresos = () => {

        const ingresos = this.props.itemsCierreSemanal.filter(i => i.orden < 100);

        return ingresos.map((b, i) => {

            return <CierreSemanalResumenItem key={i} item={b} />

        });

    };

    renderBancos = () => {
        const bancos = this.props.itemsCierreSemanal.filter(i => i.orden >= 100);

        return bancos.map((b, i) => {

            return <CierreSemanalResumenItem key={i} item={b} gastosGeneral={this.props.gastosGeneral} arcadeCompl={this.props.arcadeCompl} />

        });
    };

    renderResumen = () => {
        const { classes } = this.props;
        return (
            <Paper className={classes.paperResumenTable}>
                {this.props.resumenCierreSemanal.map((itemResume, i) => {

                    let styleClass = classes.typoOK;
                    if (itemResume.iError === 1) {
                        styleClass = classes.typoError;
                    }
                    else if (itemResume.iError === 2) {
                        styleClass = classes.typoDefault;
                    }

                    return (
                        <Typography variant="subtitle2" key={i} className={styleClass}>{itemResume.mensaje}</Typography>
                    )

                })}
            </Paper>
        )
    }

    handleObsChange = (event) => {
        this.setState({ ...this.state, observDescuadre: event.target.value });
    }

    render() {

        const { classes } = this.props;

        const mult_reopa = (this.props.centroDiaSelected.centro.reopa - 31162) / 100;

        let descuadre = this.state.acumBancos - this.state.acumIngresos + this.state.acumFondos;
        if (Math.abs(descuadre) < 0.0001) descuadre = 0.0;

        if (!this.state.showSpinner) {
            return (
                <div className={classes.root}>
                    {this.renderResumen()}
                    <div className={classes.container}>

                        <div className={classes.paperCaja}>
                            <CalendarioSemanal centro={this.props.centroDiaSelected.centro.id} fecha={this.props.centroDiaSelected.dia} user={this.props.user} semanaCerrada={this.props.isSemanaCerrada} multiplicador={mult_reopa}></CalendarioSemanal>
                        </div>

                        <div className={classes.paperCaja}>

                            <div className={classes.cajaSection} hidden>
                                <div className={classes.cajaSectionLeft}>
                                    <div className={classes.cajaSectionItem}>
                                        <Typography className={classes.cajaSectionFont} variant="subtitle1">Descuadre:  </Typography>
                                        <Tooltip title={'Diferencia entre total de Bancos y la suma del total Ingresos y Variación Fondo'} TransitionComponent={Fade} TransitionProps={{ timeout: 500 }} placement="right-start" classes={{ tooltip: this.props.classes.tooltip }}>
                                            <Typography className={classes.cajaSectionFont} variant="subtitle1"> <FloatNumberFormatText value={descuadre} /> </Typography>
                                        </Tooltip>
                                    </div>
                                </div>
                            </div>

                            <div className={classes.boxesContainer}>
                                <div className={classes.paperConcepto}>
                                    <div className={classes.conceptTitleContainer}>
                                        <Typography className={classes.conceptTitle} variant="subtitle1">Ingresos</Typography>
                                    </div>
                                    <div className={classes.containeritems}>{this.renderIngresos()}</div>
                                </div>


                                <div className={classes.paperConcepto}>
                                    <div className={classes.conceptTitleContainer}>
                                        <Typography className={classes.conceptTitle} variant="subtitle1">Bancos</Typography>
                                        <div className={classes.cajaSectionRight}>
                                            <Typography className={classes.conceptTitle} variant="subtitle1">Total:  </Typography>
                                            <Typography className={classes.conceptTitle} variant="subtitle1"><FloatNumberFormatText value={parseFloat(this.state.acumBancos.toFixed(2))} /></Typography>
                                        </div>
                                    </div>

                                    <div className={classes.containeritems}>{this.renderBancos()}</div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <Typography variant="subtitle1" color='secondary'>{'Observaciones por descuadre'}</Typography>
                    <TextField
                        className={classes.observTextField}
                        disabled={this.props.isSemanaCerrada}
                        placeholder={'Observaciones'}
                        InputProps={{
                            className: classes.inputObserv,
                        }}
                        inputProps={{ maxLength: 250 }}
                        id={'observDescuadre'}
                        value={this.state.observDescuadre}
                        variant='outlined'
                        multiline
                        rowsMax='11'
                        rows='11'
                        onChange={(event) => this.handleObsChange(event)}
                    />

                    <Button onClick={this.props.prevStep} className={classes.buttonsBottom} variant="contained" color="secondary">Atrás</Button>
                    <Button hidden={this.props.isSemanaCerrada} disabled={!this.props.centroDiaSelected.existeCierreSemanal} className={classes.buttonsBottom} variant="contained" color="primary" onClick={this.hanldeOKClick} >
                        {/*this.props.isSemanaCerrada ? 'Modificar cierre' :*/ 'Cierre definitivo'}
                    </Button>
                </div>
            );
        };

        return (
            <div className={classes.spinnerContainer}>
                <CircularProgress className={classes.spinner} color="primary" />
            </div>
        );


    };

};

CierreSemanalResumen.propTypes = {
    //state:
    user: PropTypes.object.isRequired,
    itemsCierreSemanal: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    centroDiaSelected: PropTypes.object.isRequired,
    //dispatch:
    prevStep: PropTypes.func.isRequired,
    getResumenCierreSemanal: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        itemsCierreSemanal: state.resumenCierreSemanal.items,
        resumenCierreSemanal: state.resumenCierreSemanal.resumen,
        gastosGeneral: state.resumenCierreSemanal.gastosGeneral,
        arcadeCompl: state.resumenCierreSemanal.arcadeCompl,
        observDescuadre: state.resumenCierreSemanal.observaciones,
        isLoading: state.resumenCierreSemanal.isLoading,
        centroDiaSelected: state.centroDiaSelected,
        isSemanaCerrada: state.centroDiaSelected.isSemanaCerrada
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getResumenCierreSemanal,
        cerrarSemana,
        unlockCierreSemanal,
        openDialog
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(CierreSemanalResumen));